import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { NavLink } from 'react-router-dom'
import Header from './header'
import Sidebar from './sidebar'
import { useSelector } from 'react-redux'
import MobileAppScreen from '../mobile-app-screen'
import { useLocation } from 'react-router-dom'
import { ENABLE_MOBILE_VIEW_FOR_SPECIFIC_PATHS } from './constants'

const useStyles = makeStyles(theme => ({
    rootWrapper: {
        width: '100%',
        height: '100%',
        backgroundColor: theme.background
    },
    header: {
        backgroundColor: theme.background,
        width: '100%',
        height: 75,
        borderBottom: theme.border
    },
    headerLogo: {
        width: 75,
        height: 75,
        padding: '28px 17px',
        // borderRight: theme.border,
        float: 'left'
    },
    headerContent: {
        float: 'left',
        width: 'calc(100% - 78px)',
        height: '100%'
    },
    clearBoth: {
        clear: 'both'
    },
    logoLink: {
        color: theme.textPrimary,
        fontFamily: theme.fontFamilyMain,
        textDecoration: 'none',
        fontSize: 14,
        fontWeight: 'bold'
    },
    logo: {
        width: 40,
        height: 40,
        marginTop: -10,
        backgroundImage: `url("${theme.mainLogo}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover'
    },
    mainWrapper: {
        display: 'flex',
        height: 'calc(100% - 75px)',
        width: '100%'
    },
    sidebarSpacer: {
        width: 70
    },
    contentWrapper: {
        float: 'left',
        padding: '25px 50px 25px 50px',
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden'
    },
    responsiveWrapper: {
        width: '100%',
        height: '100%'
    }
}))

export default function Root(props) {
    const classes = useStyles()
    const location = useLocation()

    const { pathname } = location
    const isEnableMobileView = ENABLE_MOBILE_VIEW_FOR_SPECIFIC_PATHS.some(
        path => path === pathname
    )

    const { token } = useSelector(state => state.main)
    const isLoggedIn = token !== null

    const { children } = props

    return (
        <React.Fragment>
            <MobileAppScreen isEnableMobileView={isEnableMobileView} />
            {isLoggedIn && (
                <div className={classes.rootWrapper}>
                    <div className={classes.header}>
                        <div className={classes.headerLogo}>
                            <NavLink className={classes.logoLink} to="/">
                                <div className={classes.logo}></div>
                            </NavLink>
                        </div>
                        <div className={classes.headerContent}>
                            <Header />
                        </div>
                        <div className={classes.clearBoth}></div>
                    </div>
                    <div className={classes.mainWrapper}>
                        <div className={classes.sidebarSpacer} />
                        <Sidebar />
                        <div className={classes.contentWrapper}>{children}</div>
                        <div className={classes.clearBoth}></div>
                    </div>
                </div>
            )}
            {!isLoggedIn && (
                <div className={classes.responsiveWrapper}>{children}</div>
            )}
        </React.Fragment>
    )
}
